import { render, staticRenderFns } from "./profile-edit.vue?vue&type=template&id=9b437e98&scoped=true&"
import script from "./profile-edit.vue?vue&type=script&lang=js&"
export * from "./profile-edit.vue?vue&type=script&lang=js&"
import style0 from "./profile-edit.vue?vue&type=style&index=0&id=9b437e98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b437e98",
  null
  
)

export default component.exports